'use strict';

(function () {
  angular
    .module('specsguardApp')
    .controller('ProjectSettingsCtrl', ProjectSettingsCtrl);

  ProjectSettingsCtrl.$inject = ['$scope', 'Project', 'Auth', 'Utils', 'Constants', 'errorMessageService',
    '$stateParams', 'ProjectDataservice', 'Labels', '$mdDialog', '$state', 'ProjectStore', '$injector'];

  function ProjectSettingsCtrl ($scope, Project, Auth, Utils, Constants, errorMessageService,
    $stateParams, ProjectDataservice, Labels, $mdDialog, $state, projectStore, $injector) {

    const vm = this;
    vm.project = projectStore.get();
    vm.LABELS = Labels;

    Constants.getConstants().then(() => {
      vm.qualityLevels = Constants.getList('QUALITY_LEVELS');
    });

    vm.$onInit = function () {
      vm.canWrite = Utils.isUserManager(Auth, vm.project);
      vm.isAdmin = Auth.isAdmin();
      vm.isApplicationAdmin = Auth.isApplicationAdmin();

      setTimeout(() => {
        $scope.sg2AuthService = $injector.get('sg2AuthService');
      }, 100);
    };

    vm.submit = function () {
      if (vm.projectForm.$dirty) {
        const project = {
          name: vm.project.name,
          qualityLevel: vm.project.selectQualityLevel || vm.project.qualityLevel,
          clientName: vm.project.clientName,
          number: vm.project.number
        };

        const version = {
          info: vm.project.info,
          buildings: vm.project.buildings
        };

        Project.editProject({
          project,
          version,
          versionId: vm.project.versionId,
          _id: vm.project._id
        })
          .$promise
          .then((updatedProj) => {
            errorMessageService.showSuccess(vm.LABELS.getLabel('projectinformationupdated'));
            // We need to send the selectedQualityLevel to the parent $scope.model as well
            updatedProj.selectQualityLevel = vm.project.selectQualityLevel;
            vm.updateProject({project: updatedProj});
          });
      }
    };

    vm.toggleArchived = function () {
      const project = {
        archived: !vm.project.archived,
      };
      submitProject(project);
    };

    vm.toggleActive = (ev) => {
      const confirm = $mdDialog.confirm()
        .title(vm.LABELS.getLabel('areyousuredeletingproject'))
        .textContent(vm.LABELS.getLabel('projectcannotbeactivatedafterwards'))
        .targetEvent(ev)
        .ok(vm.LABELS.getLabel('delete'))
        .cancel(vm.LABELS.getLabel('cancel'));

      $mdDialog.show(confirm)
        .then(() => submitProject({active: !vm.project.active}, {active: !vm.project.active}))
        .catch(() => {});
    };

    const submitProject = (proj, version = {}) => {
      Project.editProject({
        project: proj,
        version,
        versionId: vm.project.versionId,
        _id: vm.project._id
      })
        .$promise
        .then((updatedProject) => {
          vm.updateProject({project: updatedProject});
          const succesLabel = !updatedProject.active ? vm.LABELS.getLabel('projectdeleted') :
            (updatedProject.archived ? vm.LABELS.getLabel('projectarchived') : vm.LABELS.getLabel('projectactivated'));
          errorMessageService.showSuccess(succesLabel);
          if (!updatedProject.active) {
            $state.go('project');
          }
        })
        .catch(function () {
          errorMessageService.showError(vm.LABELS.getLabel('errorprojectstatusupdate'));
        });
    };

  }
})();
